import i18n from '@/plugins/i18n'
import CompanyServicesRepository from '@/repositories/CompanyServicesRepository'

export const LOGIN_EDGE_CASES = function (domain, travelCompany, startDate, endDate, token) {
    return {
        INDITEX_OLD_EMPLOYEE: {
            message: i18n.t('login.errors.message360'),
            view: '/error/unauthorized/360'
        },
        ZARA_EXPIRED: {
            message: i18n.t('login.errors.zaraExpired'),
            view: '/error/unauthorized/360'
        },
        DENIED_ACCESS: {
            message: i18n.t('login.errors.message360'),
            view: '/error/unauthorized/360'
        },
        ZARA_PILOT_END: {
            message: i18n.t('login.errors.zaraPilotEnd'),
            view: '/error/unauthorized/360'
        },
        COPAYMENT_ENABLED: {
            message: i18n.t('login.errors.copaymentEnabled')
        },
        SANTANDER_PAID_SERVICE: {
            message: i18n.t('login.errors.santanderPaidService')
        },
        TRAVEL_EXPIRED: {
            message: i18n.t('login.errors.travelExpired', { travelCompany, endDate, domain }),
            view: `/error/unauthorized/travel?t=${token}`,
        },
        TRAVEL_NOT_STARTED_YET: {
            message: i18n.t('login.errors.travelNotStartedYet', { travelCompany, startDate }),
            view: '/error/unauthorized/360'
        },
        EXPIRED: {
            message: i18n.t('login.errors.expired', { domain }),
            view: '/error/unauthorized/360'
        },
        EMPLOYEE_NUMBER_NOT_ACTIVE:{
            message: i18n.t('login.errors.message360',{ domain }),
            view: '/error/unauthorized/360'
        },
        DENIED_ACCESS_SPOUSE: {
					message: i18n.t('login.errors.deniedAccessSpouse',{ domain }),
					view: '/error/unauthorized/360'
				},
				WELLWO_ONLY_TYPE_CODE: {
					callback: () => {
						CompanyServicesRepository.getWellwoUrl().then((response) => {
							window.location.href = response.data
						})
					}
				}
    }
}


// WEBPACK FOOTER //
// ./src/constants/loginEdgeCases.js